module.exports = __webpack_public_path__ + "static/img/stay-option-icon-terrace.a879e1b0.svg";